import { connect } from 'react-redux';

import { GET_LIST_ROOM_OF_PLACE, GET_PLACE_PRICE_TYPES, UPDATE_PRICE_ROOM } from 'store/place/actionTypes';

import Price from './Price';

const mapStateToProps = (state) => ({
  isLoadingUpdatePriceRoom: state.Place.isLoadingUpdatePriceRoom,

  placePriceTypes: state.Place.placePriceTypes,
  roomOfPlaceList: state.Place.roomOfPlaceList,
  setting: state.Setting.setting,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetListRoomsOfPlace: (payload) => {
    dispatch({
      type: GET_LIST_ROOM_OF_PLACE,
      payload,
    });
  },

  actionGetPlacePriceTypes: (payload) => {
    dispatch({
      type: GET_PLACE_PRICE_TYPES,
      payload,
    });
  },

  actionUpdatePriceRoom: (payload) => dispatch({
    type: UPDATE_PRICE_ROOM,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Price);
